export default __webpack_public_path__ + "static/media/116-5861-018.972bb86a.png";